/** PURE_IMPORTS_START ._PairsObservable PURE_IMPORTS_END */
import { PairsObservable } from './PairsObservable';
export var pairs = PairsObservable.create;
//# sourceMappingURL=pairs.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/observable/pairs.js
// module id = 779
// module chunks = 0